const recentFiles = [
    {
        id: 1,
        name: 'index.html',
        date: '12-10-2020, 09:45',
        size: '09 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-file-document'
    },
    {
        id: 2,
        name: 'Project-A.zip',
        date: '11-10-2020, 17:05',
        size: '115 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-folder-zip   text-warning'
    },
    {
        id: 3,
        name: 'Img-1.jpeg',
        date: '11-10-2020, 13:26',
        size: '86 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-image text-muted'
    },
    {
        id: 4,
        name: 'update list.txt',
        date: '10-10-2020, 11:32',
        size: '08 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-text-box text-muted'
    },
    {
        id: 5,
        name: 'Project B',
        date: '10-10-2020, 10:51',
        size: '72 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-folder text-warning'
    },
    {
        id: 6,
        name: 'Changes list.txt',
        date: '09-10-2020, 17:05',
        size: '07 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-text-box text-muted'
    },
    {
        id: 7,
        name: 'Img-2.png',
        date: '09-10-2020, 15:12',
        size: '31 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-image text-success'
    },
    {
        id: 8,
        name: 'Project C',
        date: '09-10-2020, 10:11',
        size: '20 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'mdi mdi-folder text-warning'
    },
    {
        id: 9,
        name: 'starter-page.html',
        date: '08-10-2020, 03:22',
        size: '11 KB',
        actions: ['Open', 'Edit', 'Rename', 'Remove'],
        icon: 'bx bxs-file'
    }
]
export { recentFiles }